<template>
  <div class="metal_changed_pic">
    <!-- 金牌底圖 -->
    <img :src="imageUrl" />

    <!-- 文字覆蓋層 -->
    <div class="metal-text">
      <!-- 門牌圖片 -->
      <div class="doorplate_image">
        <img
          v-if="
            $store.getters.currentCustom.engraving_content.content
              .commemorativeDoorplateImageOption === 'tainan'
          "
          src="@/images/tainan_aw.png"
          alt="tainan"
        />
      </div>
      <!-- 縣市區域（垂直） -->
      <div class="commemorativeDoorplateDistrict">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <!-- 路名（水平） -->
      <div class="commemorativeDoorplateRoadName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>

      <!-- 門牌號（水平） -->
      <div class="commemorativeDoorplateHouseNumber">
        <div class="textContainer">
          <span class="text" v-html="textInfo[2].textContent"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/commonMixin.js";

export default {
  name: "CustomizeMetalAW",
  mixins: [commonMixin],

  data() {
    return {
      textInfo: [
        // [0] 縣市區域（垂直）
        {
          name: "commemorativeDoorplateDistrict",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateDistrict.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateDistrict.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateDistrict.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        // [1] 路名（水平）
        {
          name: "commemorativeDoorplateRoadName",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateRoadName.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateRoadName.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateRoadName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        // [2] 門牌號（水平）
        {
          name: "commemorativeDoorplateHouseNumber",
          lineLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateHouseNumber.lineLimit,
          textLimit:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateHouseNumber.textLimit,
          maxFontsize:
            this.$store.getters.textSettingByComponentCode("AW")
              .commemorativeDoorplateHouseNumber.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
      ],
    };
  },

  mounted() {
    // Step 1: 初始化水平文字環境（for RoadName & HouseNumber）
    this.calcEmFontsizeBase();

    // Step 2: 初始化垂直文字環境（for District）
    this.verticalCalcEmFontsizeBase();

    // Step 3: 處理縣市區域（垂直，verticalTextInfo index 0）
    this.verticalControlWrap(0, this.customTextDistrict);
    this.verticalControlFontsize(0, this.customTextDistrict);

    // Step 4: 處理路名（水平，textInfo index 1）
    this.controlWrapNotReverse(1, this.customTextRoadName);
    this.controlFontsize(1, this.customTextRoadName);

    // Step 5: 處理門牌號（水平，textInfo index 2）
    this.controlWrapNotReverse(2, this.customTextHouseNumber);
    this.controlFontsize(2, this.customTextHouseNumber);
  },

  computed: {
    imageUrl() {
      const metalData =
        this.$store.getters.customizeMetalDataByComponentCode("AW");
      return metalData.imagePath;
    },

    // 從 store 讀取用戶輸入的文字
    customTextDistrict() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeDoorplateDistrict;
    },
    customTextRoadName() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeDoorplateRoadName;
    },
    customTextHouseNumber() {
      return this.$store.getters.currentCustom.engraving_content.content
        .commemorativeDoorplateHouseNumber;
    },

    // verticalTextInfo - 提供給 commonMixin 的垂直方法使用
    // 過濾出垂直文字區域（僅 District）
    verticalTextInfo() {
      return this.textInfo.filter(
        (item) => item.name === "commemorativeDoorplateDistrict"
      );
    },
  },

  watch: {
    // 監聽縣市區域變化（垂直）
    customTextDistrict() {
      this.verticalControlWrap(0, this.customTextDistrict);
      this.verticalControlFontsize(0, this.customTextDistrict);
    },

    // 監聽路名變化（水平）
    customTextRoadName() {
      this.controlWrapNotReverse(1, this.customTextRoadName);
      this.controlFontsize(1, this.customTextRoadName);
    },

    // 監聽門牌號變化（水平）
    customTextHouseNumber() {
      this.controlWrapNotReverse(2, this.customTextHouseNumber);
      this.controlFontsize(2, this.customTextHouseNumber);
    },
  },
};
</script>

<style scoped lang="scss">
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";

  img {
    width: 100%;
  }

  .metal-text {
    position: absolute;
    top: 49px;
    left: 21px;
    color: $primaryLightColor;
    font-weight: 800;

    // 響應式縮放（參考 CustomizeMetalAV）
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 11px;
      left: 10px;
    }
    @include table {
      transform: scale(0.7);
      top: -9px;
      left: 0px;
    }
    @include phone {
      transform: scale(0.64);
      top: -21px;
      left: -5px;
    }
  }
}

.doorplate_image {
  width: 110px;
  height: 110px;
  border: 1px dashed $primaryLightColor;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 62px;
  }
}

// 縣市區域（垂直）
.commemorativeDoorplateDistrict {
  height: 175px;
  width: 68px;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  margin-top: 1px;

  .textContainer {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      white-space: nowrap;
      writing-mode: vertical-rl; // CSS 垂直書寫模式
      text-orientation: upright; // 字符直立
    }
  }
}

// 路名（水平）
.commemorativeDoorplateRoadName {
  width: 310px;
  height: 82px;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 14px;
  left: 128px;

  .textContainer {
    width: 100%;
    text-align: center;

    span {
      white-space: nowrap;
    }
  }
}

// 門牌號（水平，最大字體）
.commemorativeDoorplateHouseNumber {
  width: 310px;
  height: 138px;
  border: 1px dashed $primaryLightColor; // 測試用邊框
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 121px;
  left: 128px;

  .textContainer {
    width: 100%;
    text-align: center;

    span {
      white-space: nowrap;
    }
  }
}
</style>
